import { useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function DeletionRequestLineGraph(props) {
  let myData = props?.data || [];
 useLayoutEffect(() => {
    let root = am5.Root.new("linediv");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panY: false,
        layout: root.verticalLayout
      })
    );

    // Define data
    /*let data = [{
      month: "Jan",
      value: 10
    }, {
      month: "Feb",
      value: 5
    }, {
      month: "March",
      value: 8
    }];*/

    let data = myData || [];

    // Create Y-axis
    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {})
      })
    );

    // Create X-Axis
    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
    renderer: am5xy.AxisRendererX.new(root, {}),
        categoryField: "month"
      })
    );
    xAxis.data.setAll(data);

    // Create series
    let series1 = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Series",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "count",
        categoryXField: "month"
      })
    );
    series1.data.setAll(data);


    // Add legend
    let legend = chart.children.push(am5.Legend.new(root, {}));
    legend.data.setAll(chart.series.values);

    // Add cursor
    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    return () => {
      root.dispose();
    };
  }, []);
  if (!myData?.length) {
    return <h5 className="text-center p-4">No Data Available.</h5>;
  }
 

  return (
    <div id="linediv" style={{ width: "100%", height: "500px" }}></div>
  );
}
export default DeletionRequestLineGraph;